import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { InteractionModalContainer } from ".";
import useClaimAirdrop from "../../hooks/useClaimAirdrop";
import useGenericCall from "../../hooks/useGenericCall";
import useOnchain, { useOnchainAccount } from "../../hooks/useOnchain";
import { formatAmount } from "../../utils/format";
import InteractionButton, { ButtonState } from "../InteractionButton";


export interface AccountModalProps {
  show: boolean;
  toggleShow(s: boolean): void;
}

export default function ClaimAirdropModal({show, toggleShow}: AccountModalProps) {  
  const onchain = useOnchain();
  const airdropDataIbex = useGenericCall(useOnchainAccount(), onchain => onchain.getIbexAirdropData());
  const airdropDataIbex2 = useGenericCall(useOnchainAccount(), onchain => onchain.getIbex2AirdropData());
  const airdropDataEth = useGenericCall(useOnchainAccount(), onchain => onchain.getEthAirdropData());
  const [claimAirdropIbexState, claimAirdropIbex] = useClaimAirdrop(airdropDataIbex, onchain ? onchain.getContractHelper().merkleDistributorIbex : null);
  const [claimAirdropIbex2State, claimAirdropIbex2] = useClaimAirdrop(airdropDataIbex2, onchain ? onchain.getContractHelper().merkleDistributorIbex2 : null);
  const [claimAirdropEthState, claimAirdropEth] = useClaimAirdrop(airdropDataEth, onchain ? onchain.getContractHelper().merkleDistributorEth : null);

  return (
    <InteractionModalContainer title="Claim Airdrop" show={show} toggleShow={toggleShow}><>
      {airdropDataIbex && airdropDataIbex.amount && (<>
        <Row className="mt-2">
          <Col>You can claim { formatAmount(parseFloat(airdropDataIbex.amount.toString()) / 1e18) } IBEX</Col>
        </Row>
        <Row className="interaction-row mt-2">
          <Col>
            <InteractionButton name="Claim IBEX"  onCall={claimAirdropIbex} state={claimAirdropIbexState} />
          </Col>
        </Row> 
      </>)}
      {airdropDataIbex2 && airdropDataIbex2.amount && airdropDataIbex && airdropDataIbex.amount && (
        <Row className="mt-4"></Row>
      )}
      {airdropDataIbex2 && airdropDataIbex2.amount && (<>
        <Row className="mt-2">
          <Col>You can claim { formatAmount(parseFloat(airdropDataIbex2.amount.toString()) / 1e18) } IBEX</Col>
        </Row>
        <Row className="interaction-row mt-2">
          <Col>
            <InteractionButton name="Claim IBEX (second part)"  onCall={claimAirdropIbex2} state={claimAirdropIbex2State} />
          </Col>
        </Row> 
      </>)}
      {airdropDataEth && airdropDataEth.amount && airdropDataIbex && airdropDataIbex.amount && (
        <Row className="mt-4"></Row>
      )}
      {airdropDataEth && airdropDataEth.amount && (<>
        <Row className="mt-2">
          <Col>You can claim { formatAmount(parseFloat(airdropDataEth.amount.toString()) / 1e18) } WETH</Col>
        </Row>
        <Row className="interaction-row mt-2">
          <Col>
            <InteractionButton name="Claim WETH"  onCall={claimAirdropEth} state={claimAirdropEthState} />
          </Col>
        </Row> 
      </>)}
    </></InteractionModalContainer>
  );
}